// extracted by mini-css-extract-plugin
export default {"itemContainer":"Item_itemContainer__9Ssoc"};